<footer>
    <div class="footer-inner">
        <p>{{getFooterText()}}</p>
        <p><a href="https://collexus.com/">Powered by Collexus</a></p>
    </div>

    <app-tcn-chat></app-tcn-chat>
</footer>